/* tslint:disable */
/* eslint-disable */
/**
 * Speechmatics ASR REST API
 * The Speechmatics Automatic Speech Recognition REST API is used to submit ASR jobs and receive the results. The supported job type is transcription of audio files.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@speechmatics.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface TranslationError
 */
export interface TranslationError {
  /**
   *
   * @type {string}
   * @memberof TranslationError
   */
  type?: TranslationErrorTypeEnum;
  /**
   * Human readable error message
   * @type {string}
   * @memberof TranslationError
   */
  message?: string;
}

export const TranslationErrorTypeEnum = {
  TranslationFailed: 'translation_failed',
  UnsupportedTranslationPair: 'unsupported_translation_pair',
} as const;

export type TranslationErrorTypeEnum =
  (typeof TranslationErrorTypeEnum)[keyof typeof TranslationErrorTypeEnum];
